import React, { useState } from "react";
import "./NavBar.scss";
import { Link } from "react-router-dom";

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const offset = section.getBoundingClientRect().top;
      const scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;

      const targetScrollPosition = scrollPosition + offset - 80;

      window.scrollTo({
        top: targetScrollPosition,
        behavior: "smooth",
      });
    }
    closeMenu();
  };

  return (
    <section className={`top-nav ${isMenuOpen ? "menu-open" : ""}`}>
      <input
        id="menu-toggle"
        type="checkbox"
        checked={isMenuOpen}
        onChange={toggleMenu}
      />
      <label className="menu-button-container" htmlFor="menu-toggle">
        <div className="menu-button"></div>
      </label>
      <ul className="menu">
        <li onClick={() => scrollToSection("Home")}>Home</li>
        <li onClick={() => scrollToSection("Institutional")}>Institutional</li>
        <li onClick={() => scrollToSection("Representations")}>
          Representations
        </li>
        <li onClick={() => scrollToSection("Services")}>Services</li>
        <li onClick={() => scrollToSection("Forms")}>Forms</li>
        <li onClick={() => scrollToSection("LinksOfInterest")}>
          Links of Interest
        </li>
        <li onClick={() => scrollToSection("Contact")}>Contact</li>
      </ul>
      <div className="containerimg">
        <img className="containerimg-img" src="./NavBar/blanco.png"></img>
      </div>
      <Link className="traduc" to={"/ "}>
        <img className="traduc-img" src="./NavBar/arg.png"></img>
        <div className="traduc-txt">Español</div>
      </Link>
    </section>
  );
};

export default NavBar;
